<script setup>
import { Head, Link } from '@inertiajs/inertia-vue3';
import MainLayout from '../../Layouts/MainLayout';
import {ref} from "vue";
import useRotas from '../../Composables/useRotas';

const route = useRotas();
const emailContato = ref(window.doulheTresConfig.email_contato);
const telefoneContato = ref(window.doulheTresConfig.telefone_contato);

</script>

<template>
    <Head title="Empresa"/>
    <MainLayout>
        <q-page>
            <div
                class="flex q-mx-sm column wrap items-center"
            >
                <div
                    class="flex q-pt-lg row"
                >
                    <div
                        class="text-primary q-pa-none full-width"
                    >
                        <h1 class="
                                text-center text-primary text-h4 text-bold full-width
                                q-my-md
                            ">
                            Empresa
                        </h1>
                        <h2 class="
                                text-center text-h5 full-width
                                q-my-md
                            "
                            style="color: rgb(194, 0, 11);"
                        >
                            Há mais de 40 anos conectando pessoas a grandes oportunidades
                        </h2>
                        <p class="text-center text-italic q-px-md">
                            Em cada martelo batido, a realização de um negócio e a conquista de um sonho.
                        </p>
                    </div>
                </div>
                <div
                    :class="$q.screen.lt.sm ? '' : 'q-px-xl'"
                    class="q-pt-md col-12 row items-start "
                >
                    <div class="col col-12 col-md-6 col-sm-12  q-px-md">
                        <h6 class="
                                text-center text-primary text-h6 full-width
                                q-my-md titulo-borda
                            ">
                            Quem Somos
                        </h6>
                        <p>
                            Fundada em 1984, na cidade de Fortaleza (CE), a <b>Montenegro Leilões</b> nasceu com um propósito claro: construir a ponte mais segura e confiável entre grandes oportunidades e as pessoas. Ao longo de mais de quatro décadas, transformamos essa missão em referência, realizando leilões de veículos, imóveis e bens diversos com máxima transparência.
                        </p>
                        <p class="text-bold titulo-borda">
                            Uma trajetória construída sobre confiança
                        </p>
                        <p>
                            A confiança que edificamos ao longo de décadas é o nosso bem mais valioso. Ela se reflete em cada aspecto do nosso trabalho e se traduz em resultados: hoje somos uma das plataformas de leilões mais consolidadas do Norte e Nordeste, com atuação nos segmentos <b>judicial e extrajudicial</b>, reunindo oportunidades que vão desde imóveis e veículos até maquinário e bens diversos.
                        </p>
                        <p>
                            Atendemos grandes bancos, financeiras, consórcios, órgãos públicos e judiciais e diversas instituições privadas que confiam à Montenegro a gestão e a liquidação de seus ativos — sempre com a mesma dedicação com que atendemos quem participa de seu primeiro lance.
                        </p>
                        <p class="text-bold">
                            A Montenegro faz acontecer.
                        </p>
                        <p class="text-bold titulo-borda">
                            O que oferecemos
                        </p>
                        <p>
                            Muito mais do que um pregão. Uma solução completa para comprar e vender com segurança:
                        </p>
                        <ul class="lista-bolinha">
                            <li>Leilões de veículos, imóveis e bens diversos</li>
                            <li>Tudo 100% online, lance de qualquer lugar do país</li>
                            <li>Suporte completo antes, durante e após o leilão, com equipe especializada e dedicada</li>
                            <li>Transmissão em tempo real no Auditório de Disputa</li>
                            <li>Orientação pós-leilão para finalização e pagamento dos lotes arrematados</li>
                            <li>Atendimento humano, ágil e transparente do início ao fim</li>
                        </ul>
                        <p class="text-bold titulo-borda">
                            Nosso Propósito
                        </p>
                        <p class="text-italic">
                            Transformar ativos em oportunidades e oportunidades em conquistas.
                        </p>
                        <p>
                            É assim que geramos valor real para todos os lados: damos liquidez a quem precisa vender e abrimos as portas de grandes oportunidades para quem quer comprar. Cada leilão bem-sucedido movimenta a economia e realiza projetos — e é nisso que acreditamos.
                        </p>
                        <p class="text-bold titulo-borda">
                            Missão e Visão
                        </p>
                        <p>
                            <b>Nossa missão</b> é ser a ponte entre pessoas e grandes conquistas, conduzindo cada leilão com transparência, segurança e credibilidade, para que vender e comprar em leilão seja sempre uma experiência confiável e vantajosa.
                        </p>
                        <p>
                            <b>Nossa visão</b> está sempre no futuro. Buscamos expandir constantemente a variedade de bens em nossos leilões e inovar em tecnologia para tornar a experiência da compra cada vez mais dinâmica e acessível. Queremos ser a melhor e mais confiável plataforma de leilões da região — sempre competitivos e gerando valor real para nossos clientes.
                        </p>
                        <p class="text-bold titulo-borda">
                            Nossos Valores
                        </p>
                        <p>
                            São eles que sustentam cada lance, cada processo e cada relação que construímos:
                        </p>
                        <ul class="lista-bolinha">
                            <li><b>Respeito absoluto —</b> por nossos clientes, parceiros e equipe, em toda e qualquer interação.</li>
                            <li><b>Excelência no atendimento —</b> oferecendo suporte de ponta em todas as etapas do leilão.</li>
                            <li><b>Transparência e credibilidade —</b> em cada lance, em cada lote e em cada processo.</li>
                            <li><b>Ética e comprometimento —</b> que garantem a segurança e a lisura de todos os nossos leilões.</li>
                        </ul>
                        <p class="text-bold titulo-borda">
                            Nossa Estrutura
                        </p>
                        <p>
                            Para garantir a segurança e a integridade de cada bem confiado a nós, investimos em uma estrutura que somam <b>20.000 m² de área</b>, totalmente protegidos com monitoramento 24 horas e uma equipe dedicada à guarda e conservação dos lotes.
                        </p>
                        <ul class="lista-bolinha">
                            <li><b class="numero-destaque">40+</b> anos de tradição no mercado de leilões</li>
                            <li><b class="numero-destaque">20.000 m²</b> de pátios monitorados 24 horas</li>
                            <li><b class="numero-destaque">100%</b> de foco em transparência e segurança em cada operação</li>
                        </ul>
                        <p class="text-bold titulo-borda">
                            Credibilidade e confiança
                        </p>
                        <p>
                            A solidez do nosso trabalho é atestada por parcerias de longa data com grandes bancos, financeiras, consórcios, órgãos públicos e judiciais e diversas instituições privadas que confiam em nossa presteza e capacidade de gerar resultados.
                        </p>
                        <p>
                            Seja para comprar ou vender, junte-se a milhares de clientes satisfeitos e descubra a melhor oportunidade para você.
                            <Link :href="route('home')" class="text-primary text-bold"> Explore nossos leilões.</Link>
                        </p>
                    </div>

                    <div class="flex col col-12 col-md-6 col-sm-12 q-px-md">

                        <h6 class="
                                text-center text-primary text-h6 full-width
                                q-my-md titulo-borda
                            ">
                            Nossos Leiloeiros Oficiais
                        </h6>
                        <p>
                            Todos os nossos leilões são conduzidos por leiloeiros oficiais devidamente matriculados na Junta Comercial do Estado do Ceará (JUCEC) — garantia de que cada pregão segue rigorosamente a legislação e os mais altos padrões de idoneidade.
                        </p>


                            <div class="q-pa-none full-width">
                                <div class="q-gutter-md full-width row justify-around">
                                    <div class="column flex items-center">
                                        <q-avatar size="160px">
                                            <q-img
                                                src="https://assets.montenegroleiloes.paganini.tech/institucional/galeria/Fernando-Montenegro-Castelo.png"
                                                style="width: 160px; height: 160px;"
                                                fit="fill"
                                            >
                                            </q-img>
                                        </q-avatar>
                                        <span class="q-mt-sm text-center">
                                            <b>Fernando Montenegro Castelo</b><br/>
                                            Matricula na JUCEC 001/1984
                                        </span>
                                    </div>
                                    <div class="column flex items-center">
                                        <q-avatar size="160px">
                                            <q-img
                                                src="https://assets.montenegroleiloes.paganini.tech/institucional/galeria/Daniela-de-Souza-Castelo.png"
                                                style="width: 160px; height: 160px;"
                                                fit="fill"
                                            >
                                            </q-img>
                                        </q-avatar>
                                        <span class="q-mt-sm text-center">
                                            <b>Daniela de Souza Castelo</b><br/>
                                            Matricula na JUCEC 023/2012
                                        </span>
                                    </div>
                                    <div class="column flex items-center">
                                        <q-avatar size="160px">
                                            <q-img
                                                src="https://assets.montenegroleiloes.paganini.tech/institucional/galeria/Georgia-de-Souza-Castelo.png"
                                                style="width: 160px; height: 160px;"
                                                fit="fill"
                                            >
                                            </q-img>
                                        </q-avatar>
                                        <span class="q-mt-sm text-center">
                                            <b>Geórgia de Souza Castelo</b><br/>
                                            Matricula na JUCEC 024/2016
                                        </span>
                                    </div>
                                    <div class="column flex items-center">
                                        <q-avatar size="160px">
                                            <q-img
                                                src="https://assets.montenegroleiloes.paganini.tech/institucional/galeria/Joao-Paulo-Ferreira.png"
                                                style="width: 160px; height: 160px;"
                                                fit="fill"
                                            >
                                            </q-img>
                                        </q-avatar>
                                        <span class="q-mt-sm text-center">
                                            <b>João Paulo Ferreira</b><br/>
                                            Matricula na JUCEC 039/2021
                                        </span>
                                    </div>

                                </div>
                            </div>

                        <h6 class="
                                text-center text-primary text-h6 full-width
                                q-my-md titulo-borda
                            ">
                            Pátio e Escritório
                        </h6>
                        <p>
                            <b>MATRIZ</b><br/><br/>
                            Rua Ademar Paula, 1000 – Esplanada do Castelão - CEP: 60.867-640 – Fortaleza/CE
                            <br/>
                            Horários de funcionamento: De Segunda a Sexta - 08h as 11:30 – 13h as 16:30
                            <br/>
                            Telefone: {{ telefoneContato }}<br/>
                            E-mail: {{ emailContato }}<br/>
                        </p>

                    </div>
                </div>
            </div>
        </q-page>
    </MainLayout>
</template>

<style scoped>
.titulo-borda {
    border-bottom: 1.5px solid rgb(194, 0, 11);
    padding-bottom: 8px;
}

.lista-bolinha {
    margin: 0 0 16px;
    padding-left: 1.25em;
}

.lista-bolinha li {
    margin-bottom: 6px;
}

.lista-bolinha li::marker {
    color: rgb(194, 0, 11);
}

.numero-destaque {
    color: rgb(194, 0, 11);
}
</style>
